export default "__VITE_ASSET__BraBOKoi__"